/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-console */
import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import styled from 'styled-components';
import { Input } from '@vds/inputs';
import { getGeoCode } from './services';

const SearchList = styled.li`
  padding: 10px;
  list-style: none;
  border: solid 1px #d8dada;
  cursor: pointer;
  font-family: NHGrotesk !important;
  line-height: 1.9;
  :hover,
  :focus {
    background-color: #f6f6f6;
  }
`;

const SearchListContainer = styled.div`
  position: absolute;
  background-color: white;
  z-index: 1;
  max-height: 400px;
  overflow: auto;
  box-shadow: 0 6px 12px rgb(0 0 0 / 18%);
`;

const INPUTCONTAINER = styled.div`
  position: relative;
  & Input:focus {
    outline: 1px dashed #000 !important;
    outline-offset: 4px;
  }
  .search_ispu {
    background-color: transparent;
    display: inline-block;
    height: 1.25rem;
    width: 1.25rem;
    min-height: 1.25rem;
    min-width: 1.25rem;
    position: absolute;
    right: 10px;
    top: 32px;
  }
`;

const maxLengthCheck = (object) => {
  const newObj = { ...object };
  if (object.target.value.length > object && object.target && object.target.maxLength) {
    newObj.target.value =
      object && object.target && object.target.value && object.target.value.slice(0, object && object.target && object.target.maxLength);
  }
};

const handleInputkeyUp = (e) => {
  if (e.keyCode === 40) {
    const searchList = document.querySelector('#searchList');
    if (searchList) {
      searchList.children[0].focus();
    }
  }
};

class LocationSearchInput extends React.Component {
  static defaultProps = {
    address: {
      zipcode: '',
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      address: props.address.zipcode,
      showAddressTypeAhead: false,
      searchType: true,
      searchText: props.address.zipcode,
      showError: false,
      message: 'You must enter a zip code',
    };
  }

  componentDidMount = () => {
    if (this.props.address && this.props.address.zipcode) {
      if (!window.searchLocation) {
        // Hack fix setting this due to VDS remounting the Modal component
        this.onClickSearch(this.props.address.zipcode);
      }
    }
  };

  onAddressSearchChange = (e) => {
    const re = /^[0-9\b]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      this.setState({ searchText: e.target.value });
      e.persist();
      // if (this.addressTimer) {
      //   clearTimeout(this.addressTimer);
      // }
      this.addressTimer = this.getAddress(e.target.value);
    }
  };

  onBlurChange = () => {
    // setTimeout(() => {
    //   this.setState({
    //     // showAddressTypeAhead: false,
    //     address: [],
    //   });
    // }, 300);
  };

  onClickOfTypeAhead = (option) => {
    try {
      const { typeaheadAPIKey } = this.props;
      const { zip } = option;
      if (option && option.city) {
        getGeoCode(zip, typeaheadAPIKey)
          .then((res) => {
            if (res && res.position) {
              const obj = res.position;
              const updatedFormData = {
                latitude: obj.lat,
                longitute: obj.lng,
                zipCode: zip,
              };
              this.setState({ showAddressTypeAhead: false, searchText: zip });
              if (this.props.checkStores) {
                this.props.checkStores(updatedFormData);
              }
            } else {
              this.setState({ showError: true, showAddressTypeAhead: false });
            }
          })
          .catch((error) => {
            console.log('error on searchSelectedLocation', error);
            this.setState({ showError: true, showAddressTypeAhead: false });
          });
      } else {
        this.setState({ showError: false });
      }
    } catch (error) {
      console.log('Error in GetGeoCode Service:', error);
    }
  };

  onClickSearch = (inputText) => {
    const { typeaheadAPIKey } = this.props;

    getGeoCode(inputText, typeaheadAPIKey)
      .then((res) => {
        if (res && res.position) {
          const obj = res.position;
          const updatedFormData = {
            latitude: obj.lat,
            longitute: obj.lng,
            zipCode: inputText,
          };
          this.setState({ showAddressTypeAhead: false, searchText: inputText });
          if (this.props.checkStores) {
            this.props.checkStores(updatedFormData);
          }
        } else {
          this.setState({ showError: true, showAddressTypeAhead: false });
        }
      })
      .catch((error) => {
        console.log('error on searchSelectedLocation', error);
        this.setState({ showError: true, showAddressTypeAhead: false });
      });
  };

  getAddress = (searchText) => {
    try {
      if (searchText.length > 0) {
        const regExp = /^[0-9]+$/;
        const isValidZipSearch = regExp.test(searchText);
        const searchType = isValidZipSearch ? 'postalCode' : 'city';
        const { typeaheadAPIKey } = this.props;
        const request = axios({
          method: 'GET',
          url: 'https://search.hereapi.com/v1/autocomplete',
          params: {
            q: searchText,
            types: searchType,
            in: 'countryCode:USA',
            lang: 'en-US',
            limit: 5,
            apikey: typeaheadAPIKey,
          },
        });
        request
          .then((response) => {
            if (response && response.data && response.data.items) {
              const predictions = this.formattedAddress(response.data.items);
              if (predictions.length > 0) {
                this.setState({ showAddressTypeAhead: true, address: predictions, searchType: searchType === 'postalCode', showError: false });
              } else if (searchText.length === 5 && predictions.length === 0) {
                if (searchText === '00000') {
                  this.setState({ message: 'Enter a valid zip code' });
                } else {
                  this.setState({ message: `Looks like these item(s) aren't available at any stores near you. Please enter another ZIP Code` });
                }
                this.setState({ showAddressTypeAhead: false, address: [], searchType: false, showError: true });
              } else {
                this.setState({ showAddressTypeAhead: false, address: [], searchType: false, showError: true, message: 'Enter a valid zip code' });
              }
            }
          })
          .catch((error) => {
            this.setState({ showError: true });
            console.debug('Error in Autocomplete Service:', error);
          });
      } else if (searchText.length === 0) {
        this.setState({ showAddressTypeAhead: false, address: [], searchType: false, showError: true, message: 'You must enter a zip code' });
      } else {
        this.setState({ showError: false });
      }
    } catch (error) {
      console.debug('Error in Autocomplete Service:', error);
    }
  };

  formattedAddress = (data) => {
    const result = [];
    try {
      if (data && data.length > 0) {
        data.forEach((props) => {
          let countryCode = '';
          let stateCode = '';
          let zip = '';
          let city = '';
          if (props && props.address) {
            countryCode = props.address.countryCode || '';
            stateCode = props.address.stateCode || '';
            zip = props.address.postalCode || '';
            city = props.address.city || '';
          }
          if (zip !== '') {
            result.push({
              countryCode,
              stateCode,
              city,
              zip,
            });
          }
        });
      }
    } catch (error) {
      console.debug('Error In Data Formatting Section:', error);
    }
    return result;
  };

  renderTypeAheadStreetData = () => {
    const handleListkeyUp = (e) => {
      const searchInput = document.querySelector('#searchInput input');
      const nextListItem = e.target.nextElementSibling;
      const prevListItem = e.target.previousElementSibling;

      if (e.keyCode === 40) {
        if (nextListItem) {
          nextListItem.focus();
        }
      } else if (e.keyCode === 38) {
        if (prevListItem) {
          prevListItem.focus();
        } else {
          searchInput.focus();
        }
      }
    };

    let typeAheadStreetData = null;
    try {
      const { address } = this.state;
      const { showAddressTypeAhead, searchType } = this.state;
      typeAheadStreetData = (
        <div aria-live="assertive" aria-atomic="true" aria-label={`${address.length} suggestions available`}>
          {address && address.length > 0 && showAddressTypeAhead && (
            <SearchListContainer role="listbox" aria-live="assertive" id="searchList" aria-label={`Lists of ${address.length}`}>
              {address.map((option) => (
                <SearchList
                  aria-live="assertive"
                  aria-atomic="true"
                  role="option"
                  tabIndex="0"
                  aria-label={`${option && option.zip} ${option && option.city} ${option && option.stateCode} ${option && option.countryCode}`}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      this.onClickOfTypeAhead(option);
                      e.preventDefault();
                    }
                  }}
                  onClick={() => this.onClickOfTypeAhead(option)}
                  onKeyUp={(e) => handleListkeyUp(e)}
                >
                  <span role="link" tabIndex={-1}>
                    {searchType ? (
                      <span>
                        <strong>{option && option.zip}</strong>
                        <small>
                          {' '}
                          {option && option.city} {option && option.stateCode}, {option && option.countryCode}
                        </small>
                      </span>
                    ) : (
                      <span>
                        <strong>{option && option.city} </strong>
                        <small>
                          {' '}
                          {option && option.stateCode}, {option && option.countryCode}
                        </small>
                      </span>
                    )}
                  </span>
                </SearchList>
              ))}
            </SearchListContainer>
          )}
        </div>
      );
    } catch (error) {
      console.debug('Error In Data Binding Section:', error);
    }
    return typeAheadStreetData;
  };

  render() {
    const { searchText, showError, message } = this.state;
    return (
      <div className="ispu-search-input-container">
        <INPUTCONTAINER>
          <Input
            type="text"
            pattern="[0-9]*"
            label="Enter ZIP Code"
            id="ISPUInputField"
            data-testId="ISPUInputField"
            name="ISPUInputField"
            value={searchText}
            onChange={this.onAddressSearchChange}
            onBlur={this.onBlurChange}
            error={showError}
            errorText={message}
            // maxLength="5"
            maxLength={5}
            onInput={maxLengthCheck}
            onKeyUp={handleInputkeyUp}
          />
          {!showError && (
            <svg
              viewBox="0 0 21.6 21.6"
              tabIndex="0"
              role="button"
              aria-label="Zip Code Search"
              className="search_ispu"
              onClick={() => this.onClickSearch(searchText)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  this.onClickSearch(searchText);
                }
              }}
            >
              <path
                d="M19.75,19l-6-6a6.76,6.76,0,1,0-.79.79l6,6ZM8.6,14.23A5.63,5.63,0,1,1,14.23,8.6,5.63,5.63,0,0,1,8.6,14.23Z"
                stroke="none"
                fill="black"
              />
            </svg>
          )}
        </INPUTCONTAINER>
        {this.renderTypeAheadStreetData()}
      </div>
    );
  }
}

LocationSearchInput.defaultProps = {
  typeaheadAPIKey: 'VkGQbuVNQfQFWh5TCiGWuCGmAGpz8-s-4nSKH5gZ-18',
  checkStores: () => {},
};

LocationSearchInput.propTypes = {
  typeaheadAPIKey: PropTypes.string,
  checkStores: PropTypes.func,
  address: PropTypes.any,
};

export default LocationSearchInput;
